import api from '@/core/services/api';
import { toDrupalRequest } from '@/core/helpers';

export default {
    // currency
    async getCurrencyOptions({ commit, state }) {
        if (state.currencyLoading) {
            const endpoint = '/rest/api/get/currencies';
            const response = await api.get(`${toDrupalRequest(endpoint)}`);
            if (response) {
                commit('setCurrencyOptions', response.data);
                commit('setCurrencyLoading', false);
            }
        }
    },
    setCurrencySelected({ commit }, value) {
        commit('setCurrencySelected', value);
    },
    // portfolio
    async getPortfolioOptions({ commit, state }, { force = false } = {}) {
        if (!force && (state.portfolioOptions || state.portfolioLoading)) {
            return; // Already loaded or currently loading
        }
        commit('setPortfolioLoading', true);
        try {
            const endpoint = '/valuation/portfolios';
            const response = await api.get(`${toDrupalRequest(endpoint)}`);
            if (response) {
                commit('setPortfolioOptions', response);
                commit('setPortfolioIMSList', response);
            }
        } catch (error) {
            console.error('Error loading portfolio options:', error);
        } finally {
            commit('setPortfolioLoading', false);
        }
    },
    async getPortfolioTotal(_, portfolioUuid) {
        const endpoint = `valuation/summary/total/${portfolioUuid}`;
        const res = await api.get(`${toDrupalRequest(endpoint)}?mode=n`);
        if (res && res.total) {
            return res;
        } else {
            return { total: 0 };
        }
    },
    setPortfolioSelected({ commit }, value) {
        commit('setPortfolioSelected', value);
    },
    setEditPortfolioSelected({ commit }, value) {
        commit('setEditPortfolioSelected', value);
    },
    addCustomPortfolio({ commit }, payload) {
        commit('addCustomPortfolio', payload);
    },
    deleteCustomPortfolio({ commit }, payload) {
        commit('deleteCustomPortfolio', payload);
    },
    updateCustomPortfolio({ commit }, payload) {
        commit('updateCustomPortfolio', payload);
    },
    // policy
    async getPolicyOptions({ commit, state }) {
        if (state.policyLoading) {
            const endpoint = '/valuation/plans';
            const plans = await api.get(`${toDrupalRequest(endpoint)}`);
            if (plans) {
                commit('setPolicyOptions', plans);
                commit('setPolicyLoading', false);
            }
        }
    },
    setPolicySelected({ commit }, value) {
        commit('setPolicySelected', value);
    },
    setPerformancePolicySelected({ commit }, value) {
        commit('setPerformancePolicySelected', value);
    },
    // people
    async getPeopleOptions({ commit, state }) {
        if (state.peopleOptions || state.peopleLoading) {
            return; // Already loaded or currently loading
        }
        commit('setPeopleLoading', true);
        try {
            const endpoint = '/permissions/client/people';
            const response = await api.get(`${toDrupalRequest(endpoint)}`);
            if (response) {
                commit('setPeopleOptions', response);
            }
        } catch (error) {
            console.error('Error loading people options:', error);
        } finally {
            commit('setPeopleLoading', false);
        }
    },
    async getISAAllowanceUsed({ commit, state }) {
        if (state.isaAllowanceLoading) {
            const endpoint = '/isa_allowance/list';
            const response = await api.get(`${toDrupalRequest(endpoint)}`);
            if (response) {
                commit('setISAAllowanceUsed', response);
                commit('setISAAllowanceLoading', false);
            }
        }
    },
    setPeopleSelected({ commit }, value) {
        commit('setPeopleSelected', value);
    },
    // Misc
    toggleFilterPanel({ commit }) {
        commit('toggleFilterPanel');
    },
    setPeriodSelected({ commit }, value) {
        commit('setPeriodSelected', value);
    },
};
